jQuery(document).ready(function(){
	var desktopSearchContainer = jQuery('#search-wrap'),
			submitIcon = jQuery('.searchbox-icon', desktopSearchContainer),
			submitButton = jQuery('.searchbox-submit', desktopSearchContainer),
			inputBox = jQuery('.searchbox-input', desktopSearchContainer),
			searchBox = jQuery('.searchbox', desktopSearchContainer),
			isOpen = false,
			openClass = 'searchbox-open';

	submitIcon.click(function(){
		if(isOpen == false){
			searchBox.addClass(openClass);
			inputBox.focus();
			isOpen = true;
		} else {
			searchBox.removeClass(openClass);
			inputBox.focusout();
			isOpen = false;
		}
	});

	submitButton.click(function(e){
		var inputVal = inputBox.val();

		inputVal = jQuery.trim(inputVal).length;

		if( inputVal == 0){
			e.preventDefault();
			searchBox.removeClass(openClass);
			inputBox.focusout();
			isOpen = false;
		}
	});

	submitIcon.mouseup(function(){
		return false;
	});

	searchBox.mouseup(function(){
		return false;
	});

	jQuery(document).mouseup(function(){
		if(isOpen == true){
			searchBox.removeClass(openClass);
			inputBox.focusout();
			isOpen = false;
		}
	});
});
